import { render, staticRenderFns } from "./QuickPayNormalPage.vue?vue&type=template&id=40906bd4&scoped=true"
import script from "./QuickPayNormalPage.vue?vue&type=script&lang=js"
export * from "./QuickPayNormalPage.vue?vue&type=script&lang=js"
import style0 from "./QuickPayNormalPage.vue?vue&type=style&index=0&id=40906bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40906bd4",
  null
  
)

export default component.exports